import PuxTranslate from "../../../../../global/components/PuxTranslate/PuxTranslate.vue";

// @vue/component
export default {
  name: "AuszahlungUebersichtAuszahlungsplan",
  components: {
    PuxTranslate,
  },
  props: {
    auszahlungsplan: {
      type: Object,
      required: true,
    },
  },
};
